module.exports = __webpack_public_path__ + "img/spirit_big_2.2e10b1e4.png";